import React from "react";
import "./Brands.css";
function Brands() {
  return (
    <section className="Brands-wrapper">
      <div className="Brands-container innerWidth">
        <div className="Branding-container">
          <img src="./assets/content 2.jpg" alt="#" />
          <img src="./assets/content 1.jpg" alt="#" />
        </div>
      </div>
    </section>
  );
}

export default Brands;
